import React from 'react';
import classNames from 'classnames';
import ValueInput from '../value-input';
const roundValueFormatter = (v) => Math.round(v);

const BoxModelValue = ({ property, position, onChange = Function.prototype }) => {
  const classes = classNames('ws-ui-box-model__section', `ws-ui-box-model__section--${position}`);

  return (
    <div className={classes}>
      <ValueInput
        value={Number(property[position]) || 0}
        min={property.min}
        max={property.max}
        appearance="transparent"
        align="center"
        fullWidth
        bold
        valueFormatter={roundValueFormatter}
        onChange={onChange}
      />
    </div>
  );
};

export default BoxModelValue;
